import React from "react";
import { Chip } from "@mui/material";

/**
 * The "Beta" marker, in one place.
 *
 * It started as a local helper inside `Layout/Menu/SubMenu`, which meant the
 * navigation menu and any page that wanted to say the same thing said it differently.
 * Nothing here is new — it is that chip, extracted.
 *
 * ⚠️ `dense` is what the menu needs and a page title must not have. The 14px height
 * and 0.5rem type exist to fit a menu row without pushing it taller; beside an `h5`
 * the same chip reads as a typo. So the two sizes are one decision made once rather
 * than two chips that drift.
 */
export const BetaChip: React.FC<{
  dense?: boolean;
  label?: "Beta" | "New";
}> = ({ dense = false, label = "Beta" }) => (
  <Chip
    size="small"
    color="primary"
    label={label}
    sx={{
      fontWeight: 700,
      textTransform: "uppercase",
      ...(dense
        ? {
            height: "14px",
            fontSize: "0.5rem",
            "& .MuiChip-label": { px: 0.5 },
          }
        : {}),
    }}
  />
);
